var render, staticRenderFns
import script from "./AxCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AxCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AxCheckbox.vue?vue&type=style&index=0&id=57e8c85c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8c85c",
  null
  
)

export default component.exports